export default __webpack_public_path__ + "static/Augillion-457e69a5b15a0d0190dca056b4cecaa6.otf";